<template>
  <div style="height: 100%;">
    <div class="col-md-12" id="loginContainer">
      <img :src="require('../../assets/Perftech_Kocka.jpg')" style="max-height: 120px;">
      <h1 id="title-text">DocSayMobile</h1>

      <div class="card card-body">
        <form name="form" @submit.prevent="handleLogin">
          <div class="form-group">
            <label for="username">Uporabniško ime</label>
            <input
              v-model="user.username"
              v-validate="'required'"
              type="text"
              class="form-control"
              name="username"
            />
            <div
              v-if="errors.has('username')"
              class="alert alert-danger"
              role="alert"
            >Vnesite uporabniško ime</div>
          </div>
          <div class="form-group">
            <label for="password">Geslo</label>
            <input
              v-model="user.password"
              v-validate="'required'"
              type="password"
              class="form-control"
              name="password"
            />
            <div v-if="errors.has('password')" class="alert alert-danger" role="alert">Vnesite geslo</div>
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-block" :disabled="loading">
              <span v-show="loading" class="spinner-border spinner-border-sm"></span>
              <span>Prijava</span>
            </button>
          </div>
          <div class="form-group">
            <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
          </div>
        </form>
      </div>
    </div>
    <div id="footer"><img :src="require('../../assets/logo_perftech.jpg')" @click="perftechHomepage"></div>
  </div>
</template>


<script>
export default {
  name: "LoginForm",
  props: {
    msg: String,
  },
  data() {
    return {
      loading: false,
      message: "",
      user: {},
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/");
    }
  },
  methods: {
    handleLogin() {
      this.loading = true;
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        if (this.user.username && this.user.password) {
          this.$store.dispatch("auth/login", this.user).then(
            () => {
              if (this.$route.query.redirect)
                this.$router.push(this.$route.query.redirect);
              else this.$router.push("/");
            },
            () => {
              this.loading = false;
              this.message = "Uporabniško ime ali geslo ni pravilno.";
            }
          );
        }
      });
    },
    handleRedirect() {
      this.$router.push("/");
    },
    perftechHomepage() {
      window.location = "https://www.perftech.si"
    }
  },
};
</script>

<style scoped>
.alert-danger {
  color: transparent;
  border-color: transparent;
  background-color: transparent;
  color: black;
}

#title-text {
  color: #10489d;
}

#loginContainer {
  height: 90%;
}

#footer {
  height:10%;
}
</style>